// COBERTURAS-COPAGO-CALCULO-AUDIT-FIX-01 (frontend)
//
// Espejo de back_smartmedic/src/function/FCopagoCalculo.ts. El backend es la
// fuente de verdad y SIEMPRE recalcula el reparto server-side ignorando lo que
// envie el frontend; esto es solo para que la UI muestre exactamente lo que se
// va a persistir:
//
//   copago          = % que paga el paciente ([0,100])
//   precio_paciente = round2(precio_tarifa * copago / 100)
//   precio_empresa  = precio_tarifa - precio_paciente   (la empresa absorbe el centavo)

export const round2 = (n) => Math.round((Number(n) + Number.EPSILON) * 100) / 100;

export function calcularMontosCobertura(precioTarifa, copago) {
  const tarifa = round2(precioTarifa);
  const pct = Number(copago);
  if (!Number.isFinite(pct) || pct < 0 || pct > 100 || !Number.isFinite(tarifa) || tarifa < 0) {
    return { copago: Number.isFinite(pct) ? pct : 0, precioPaciente: 0, precioEmpresa: 0, valorServicio: 0 };
  }
  const precioPaciente = round2((tarifa * pct) / 100);
  const precioEmpresa = round2(tarifa - precioPaciente);
  return { copago: pct, precioPaciente, precioEmpresa, valorServicio: tarifa };
}
